import { Component } from "solid-js";
import "./index.css";
import { Artwork } from "../../types";
import { createSocialShare, X } from "@solid-primitives/share";
import { Img } from "../universal/image";
import { cleanImagePath } from "../../api";

type Props = {
    artwork: Artwork;
}

export const TwitterShareButton : Component<Props> = ({ artwork }) => {
    const shareClicked = (e: Event) => {
        e.preventDefault();
        const artistName = artwork.artist.firstName + " "  + artwork.artist.lastName;
        const artworkUrl = window.location.href;
        const description = `${artwork.title} by ${artistName}`;
        const media = `https://www.artrenewal.org${cleanImagePath(artwork.primaryImage.url)}?mode=crop&maxWidth=1000&maxHeight=1000`;
        const [share, close] = createSocialShare(() => ({
            title: description,
            url: artworkUrl,
            description,
            media,
            hashtags: "#artrenewalcenter"
        }));
        share(X);
    }
    return (
        <>
            <span style="position: relative; top: -3px;" onClick={shareClicked}>
                <Img src={"/Images/icons/twitter-circle.png"} style="height: 1em; width: auto;" />
            </span>
        </>
    );
}